<div class="scan-overlay" [class.scan-overlay--native]="isNative"
     role="dialog" aria-modal="true" aria-label="Barcode scanner">
  @if (!isNative) {
    <video #scanVideo autoplay playsinline muted class="scan-video"></video>
  }

  <div class="scan-guide">
    <div class="scan-guide__frame"></div>
    <p class="scan-guide__hint">{{ hint }}</p>
  </div>

  <ion-button class="scan-cancel-btn" fill="outline" (click)="onCancel()">
    Cancel
  </ion-button>
</div>
